angular.module('bmsApp.settings')
	.factory('EmailSettingSvc', function ($http, $log, $window, $q, CRUDSvc) {

		return {
			read: function (params) {
				return CRUDSvc.get('api/settings/email/read', params);
			},
			save: function (data) {
				return CRUDSvc.post('api/settings/email/save', data);
			}
		}

	});



